var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.44 34.56C46.019 32.5352 41.6957 16.0689 41.1522 14.0067C40.0224 9.72019 37.2265 9.71997 34.9004 9.71997C32.0681 9.71997 20.8447 9.72019 18.0124 9.72019C15.6864 9.72019 13.5483 9.72019 11.7607 14.0069C10.9171 16.0297 6.90078 32.5064 6.47998 34.5262L46.44 34.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.0591 44.28L5.93483 44.2417C3.18853 44.2393 0.0698242 36.72 0.0698242 36.72H53.9292C53.9292 36.72 50.8051 44.2824 48.0591 44.28Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.aea91ea04776c6580614e30d55789fb9.svg";
export { ForwardRef as ReactComponent };